export default "__VITE_ASSET__d1f4c948__"